
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Vendors from "../pages/vendors/page";
import Auth from "../pages/auth/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import ProviderProfile from "../pages/provider/page";
import AddListing from "../pages/add-listing/page";
import Checkout from "../pages/checkout/page";
import Pricing from "../pages/pricing/page";
import MyAccountPage from "../pages/my-account/page";
import FAQs from "../pages/faqs/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vendors",
    element: <Vendors />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/provider/:id",
    element: <ProviderProfile />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/add-listing",
    element: <AddListing />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/my-account",
    element: <MyAccountPage />,
  },
  {
    path: "/faqs",
    element: <FAQs />,
  },
];

export default routes;
